import React, { useState } from "react";
import { IoMdClose } from "react-icons/io";

const HeaderPort = ({ hide, setHide }) => {
  const [active, setActive] = useState(1);
  return (
    <div
      className="row   "
      style={{ position: "sticky", top: "0", zIndex: "99999" }}
    >
      {hide ? (
        <div className="hidesidebar">
          <div className="closeicon " onClick={() => setHide(!hide)}>
            <IoMdClose style={{ fontSize: "30px" }} />
          </div>
          <a style={{width: "100%", color:"white"}} href="#Home">
            <div
              className={` ${active === 1 ? "main_nav2" : "main_nav"}  `}
              onClick={() => setActive(1)}
            >
              Home
            </div>
          </a>
          <a style={{width: "100%", color:"white"}} href="#Skills">
            <div
              className={` ${active === 2 ? "main_nav2" : "main_nav"}  `}
              onClick={() => setActive(2)}
            >
              Skills
            </div>
          </a>
          <a style={{width: "100%", color:"white"}} href="#About_me">
            <div
              className={` ${active === 3 ? "main_nav2" : "main_nav"}  `}
              onClick={() => setActive(3)}
            >
              About Me
            </div>
          </a>
          <a style={{width: "100%", color:"white"}} href="#Contact_me">
            <div
              className={` ${active === 4 ? "main_nav2" : "main_nav"}  `}
              onClick={() => setActive(4)}
            >
              Contact Me
            </div>
          </a>
          <a style={{width: "100%", color:"white"}} href="#Projects">
            <div
              className={` ${active === 5 ? "main_nav2" : "main_nav"}  `}
              onClick={() => setActive(5)}
            >
              Projects
            </div>
          </a>
          <a style={{width: "100%", color:"white"}} href="#Footer">
            <div
              className={` ${active === 6 ? "main_nav2" : "main_nav"}  `}
              onClick={() => setActive(6)}
            >
              Footer
            </div>
          </a>
        </div>
      ) : (
        <div className="hamburger">
          <div>
            <div onClick={() => setHide(!hide)} className="Hambbu"></div>
            <div onClick={() => setHide(!hide)} className="Hambbu"></div>
            <div onClick={() => setHide(!hide)} className="Hambbu"></div>
          </div>
        </div>
      )}
    </div>
  );
};

export default HeaderPort;
